<template>
  <CommonHeader class="main_head_block" style="margin-right:25px !important;
  border-bottom: 1px solid #979797;padding-top:25px;padding-bottom:5px">
      <template v-slot:header>
          <span class="module_heading_edit">
              {{ $route.params.guardrailId && $route.params.guardrailId!='null' ? "Edit" : "Add" }} Guardrail</span>
              </template>   
  </CommonHeader>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue"
export default {
  components: { CommonHeader }
};
</script>

<style lang="scss">
.main_head_block{
  .module_heading_edit{
    height: 30px;
    color: #333333;
    font-family: "Nunito Sans";
    font-size: 22px;
    font-weight: bold;
    letter-spacing: 0.03px;
    line-height: 30px;
  }
}
</style>
